import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { ChatPage } from './ChatPage';

/**
 * Arche wrapper for Chat — provides ArcheLayout with sidebar
 * and handles sub-routing for channel selection.
 */
export function ChatArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/channel/:channelId" element={<ChatPage />} />
      </Routes>
    </ArcheLayout>
  );
}
